import { Injectable } from '@angular/core';
import * as browserImageCompression from 'browser-image-compression';

type ImageCompressionFunction = (file: File, options: any) => Promise<File>;

@Injectable({
  providedIn: 'root'
})
export class ImageCompressionService {
  // importing the function properly requires setting allowSyntheticDefaultImports to true in tsconfig.json, but I don't
  // trust that not to break anything
  private readonly imageCompression: ImageCompressionFunction = <
    ImageCompressionFunction
  >(<any>browserImageCompression).default;

  private defaultOptions = {
    maxSizeMB: 0.5,
    maxWidthOrHeight: 1920,
    useWebWorker: true
  };

  compressImage(image: File, options?: any): Promise<File> {
    return this.imageCompression(
      image,
      options == null ? this.defaultOptions : options
    );
  }
}
